import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useI18n } from '../../i18n/I18nContext';
import api from '../../utils/api';

function AdminApprovals() {
  const { user } = useAuth();
  const { t } = useI18n();

  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) loadData();
  }, [user]);

  async function loadData() {
    try {
      const data = await api.get('/admin/pending-approvals');
      setPendingUsers(data);
    } catch (err) {
      console.error('Failed to load:', err);
    } finally {
      setLoading(false);
    }
  }

  async function handleApprove(id) {
    if (!window.confirm(t('admin.approveRegistration'))) return;
    try {
      await api.post(`/admin/pending-approvals/${id}/approve`);
      loadData();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  }

  async function handleReject(id) {
    if (!window.confirm(t('admin.rejectRegistration'))) return;
    try {
      await api.delete(`/admin/pending-approvals/${id}`);
      loadData();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  }

  if (loading) {
    return <div className="flex justify-center" style={{ padding: '40px 0' }}><div className="spinner"></div></div>;
  }

  const pendingOwners = pendingUsers.filter(u => u.role === 'owner');
  const pendingVendors = pendingUsers.filter(u => u.role === 'vendor');

  return (
    <div>
      {/* Page Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 style={{ fontSize: '20px', fontWeight: '600' }}>{t('admin.pendingApprovals')}</h1>
        <span className="badge" style={{ background: 'var(--primary)', color: 'white', padding: '6px 16px', borderRadius: '16px' }}>
          {pendingUsers.length} {t('admin.pending')}
        </span>
      </div>
        {pendingUsers.length === 0 ? (
          <div className="card text-center text-secondary">
            {t('admin.noPendingRegistrations')}
          </div>
        ) : (
          <>
            {pendingOwners.length > 0 && (
              <>
                <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>
                  {t('admin.pendingOwners')} ({pendingOwners.length})
                </h2>
                {pendingOwners.map(u => (
                  <div key={u.id} className="card mb-3">
                    <div className="flex justify-between items-start">
                      <div style={{ flex: 1 }}>
                        <h3 style={{ fontSize: '16px', marginBottom: '4px' }}>{u.name}</h3>
                        <p className="text-secondary text-xs mb-2">{u.email}</p>
                        <div className="text-secondary text-xs">
                          {u.owner_phone && <span>{t('common.phone')}: {u.owner_phone} • </span>}
                          {u.owner_whatsapp && <span>WhatsApp: {u.owner_whatsapp} • </span>}
                          {u.owner_line_id && <span>LINE: {u.owner_line_id} • </span>}
                          <span>{t('admin.registeredDate')}: {new Date(u.created_at).toLocaleDateString()}</span>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleApprove(u.id)}
                          className="btn btn-primary"
                          style={{ padding: '8px 16px', fontSize: '13px' }}
                        >
                          {t('admin.approve')}
                        </button>
                        <button
                          onClick={() => handleReject(u.id)}
                          className="btn btn-secondary"
                          style={{ padding: '8px 16px', fontSize: '13px', color: 'var(--error)' }}
                        >
                          {t('admin.reject')}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            {pendingVendors.length > 0 && (
              <>
                <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', marginTop: pendingOwners.length > 0 ? '24px' : 0 }}>
                  {t('admin.pendingVendors')} ({pendingVendors.length})
                </h2>
                {pendingVendors.map(u => (
                  <div key={u.id} className="card mb-3">
                    <div className="flex justify-between items-start">
                      <div style={{ flex: 1 }}>
                        <h3 style={{ fontSize: '16px', marginBottom: '4px' }}>{u.name}</h3>
                        <p className="text-secondary text-xs mb-2">{u.email}</p>
                        <div className="text-secondary text-xs">
                          {u.vendor_email && <span>{t('admin.contactEmail')}: {u.vendor_email} • </span>}
                          {u.vendor_phone && <span>{t('common.phone')}: {u.vendor_phone} • </span>}
                          {u.vendor_line_id && <span>LINE: {u.vendor_line_id} • </span>}
                          <span>{t('admin.registeredDate')}: {new Date(u.created_at).toLocaleDateString()}</span>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleApprove(u.id)}
                          className="btn btn-primary"
                          style={{ padding: '8px 16px', fontSize: '13px' }}
                        >
                          {t('admin.approve')}
                        </button>
                        <button
                          onClick={() => handleReject(u.id)}
                          className="btn btn-secondary"
                          style={{ padding: '8px 16px', fontSize: '13px', color: 'var(--error)' }}
                        >
                          {t('admin.reject')}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        )}
    </div>
  );
}

export default AdminApprovals;
